module.exports = __webpack_public_path__ + "static/img/s4.a6e0513.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/s4.png
// module id = ZFBm
// module chunks = 0